module.exports = __webpack_public_path__ + "img/hospital_main_with_shad_and_floor.3655e41b.png";